// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1UiYn","errorLogs":"styles_errorLogs__1wpNk"};